"use strict";

export const userConstants = {
    USER_GET_LATEST_ACHIEVEMENTS_REQUEST:
        "USER_GET_LATEST_ACHIEVEMENTS_REQUEST",
    USER_GET_LATEST_ACHIEVEMENTS_COMPLETE:
        "USER_GET_LATEST_ACHIEVEMENTS_COMPLETE",

    USER_GET_THINGS_TO_DO_REQUEST: "USER_GET_THINGS_TO_DO_REQUEST",
    USER_GET_THINGS_TO_DO_COMPLETE: "USER_GET_THINGS_TO_DO_COMPLETE",

    USER_MEMBERSHIP_REQUEST: "USER_MEMBERSHIP_REQUEST",
    USER_MEMBERSHIP_COMPLETE: "USER_MEMBERSHIP_COMPLETE",

    USER_POINTS_TRANSACTIONS_REQUEST: "USER_POINTS_TRANSACTIONS_REQUEST",
    USER_POINTS_TRANSACTIONS_COMPLETE: "USER_POINTS_TRANSACTIONS_COMPLETE",

    USER_GOALS_REQUEST: "USER_GOALS_REQUEST",
    USER_GOALS_COMPLETE: "USER_GOALS_COMPLETE",

    USER_INCENTIVE_HISTORY_REQUEST: "USER_INCENTIVE_HISTORY_REQUEST",
    USER_INCENTIVE_HISTORY_COMPLETE: "USER_INCENTIVE_HISTORY_COMPLETE",

    GET_PARTICIPANT_NOTIFICATION_REQUEST:
        "GET_PARTICIPANT_NOTIFICATION_REQUEST",
    GET_PARTICIPANT_NOTIFICATION_COMPLETE:
        "GET_PARTICIPANT_NOTIFICATION_COMPLETE",

    GET_NEWS_FEED_REQUEST: "GET_NEWS_FEED_REQUEST",
    GET_NEWS_FEED_COMPLETE: "GET_NEWS_FEED_COMPLETE",

    READ_NOTIFICATION_REQUEST: "READ_NOTIFICATION_REQUEST",
    READ_NOTIFICATION_COMPLETE: "READ_NOTIFICATION_COMPLETE",

    GET_USER_POINTS_BALANCE_REQUEST: "GET_USER_POINTS_BALANCE_REQUEST",
    GET_USER_POINTS_BALANCE_COMPLETE: "GET_USER_POINTS_BALANCE_COMPLETE",

    GET_LATEST_TRANSACTIONS_REQUEST: "GET_LATEST_TRANSACTIONS_REQUEST",
    GET_LATEST_TRANSACTIONS_COMPLETE: "GET_LATEST_TRANSACTIONS_COMPLETE",

    USER_ACCOUNT_LOG_USER_STATUS_REQUEST: "USER_ACCOUNT_LOG_USER_STATUS_REQUEST",
    USER_ACCOUNT_LOG_USER_STATUS_COMPLETE: "USER_ACCOUNT_LOG_USER_STATUS_COMPLETE",
};

export const transactionType = {
    DEBIT: "DEBIT",
    CREDIT: "CREDIT",
};

export const userTypes = {
    EMPLOYEE: "Employee",
    MANAGER: "Manager",
    ADMIN: "Admin",
};
